/* eslint-disable max-lines */
import gql from "graphql-tag.macro";

const queryLoadActionLogs = gql`
    query loadActionLogs {
        actionLogs {
            edges {
                node {
                    index
                    hash
                    timestamp
                    data {
                        comment
                        who {
                            id
                            email
                        }
                        when
                        why {
                            human
                            robot {
                                relatedId
                                relatedKind
                                from
                                to
                                by
                            }
                        }
                        what {
                            path
                            value
                            from
                        }
                    }
                }
            }
        }
    }
`;

export const loadApprovalHistory = async ({ client }) => {
    const {
        data: {
            actionLogs: { edges: data },
        },
    } = await client.query(
        {
            query: queryLoadActionLogs,
            fetchPolicy: "no-cache"
        }
    );
    return data;
};
